import { render } from "./HospitalizationsTable.vue?vue&type=template&id=1e7d4cc4&ts=true"
import script from "./HospitalizationsTable.ts?vue&type=script&lang=ts&external"
export * from "./HospitalizationsTable.ts?vue&type=script&lang=ts&external"

import "./HospitalizationsTable.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__